<template>
  <require from="controls/as-page-jumbo.html"></require>

  <div class="not-implemented-screen">
    <as-page-jumbo icon="fas fa-hammer fa-fw" heading="Not Implemented" intro="Unfortunately, this screen has not been implemented yet..."></as-page-jumbo>
  </div>
</template>
